import { __awaiter, __generator } from "tslib";
import { addProp } from "@pnp/odata";
import { _Item, Item } from "../items/types.js";
import { Comments } from "./types.js";
import { spPost } from "../operations.js";
import { extractWebUrl } from "../utils/extractweburl.js";
import { combine } from "@pnp/common";
import { SharePointQueryable } from "../sharepointqueryable.js";
addProp(_Item, "comments", Comments);
_Item.prototype.getLikedBy = function () {
    return spPost(this.clone(Item, "likedBy"));
};
_Item.prototype.like = function () {
    return __awaiter(this, void 0, void 0, function () {
        var itemInfo, baseUrl, reputationUrl, likeUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getParentInfos()];
                case 1:
                    itemInfo = _a.sent();
                    baseUrl = extractWebUrl(this.toUrl());
                    reputationUrl = "_api/Microsoft.Office.Server.ReputationModel.Reputation.SetLike(listID=@a1,itemID=@a2,like=@a3)";
                    likeUrl = combine(baseUrl, reputationUrl) + ("?@a1='{" + itemInfo.ParentList.Id + "}'&@a2='" + itemInfo.Item.Id + "'&@a3=true");
                    return [2 /*return*/, spPost(SharePointQueryable(likeUrl))];
            }
        });
    });
};
_Item.prototype.unlike = function () {
    return __awaiter(this, void 0, void 0, function () {
        var itemInfo, baseUrl, reputationUrl, likeUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getParentInfos()];
                case 1:
                    itemInfo = _a.sent();
                    baseUrl = extractWebUrl(this.toUrl());
                    reputationUrl = "_api/Microsoft.Office.Server.ReputationModel.Reputation.SetLike(listID=@a1,itemID=@a2,like=@a3)";
                    likeUrl = combine(baseUrl, reputationUrl) + ("?@a1='{" + itemInfo.ParentList.Id + "}'&@a2='" + itemInfo.Item.Id + "'&@a3=false");
                    return [2 /*return*/, spPost(SharePointQueryable(likeUrl))];
            }
        });
    });
};
_Item.prototype.getLikedByInformation = function () {
    return this.clone(Item, "likedByInformation").expand("likedby")();
};
//# sourceMappingURL=item.js.map